import React, { useState } from "react";
import { useHistory, matchPath, useLocation } from "react-router-dom";
import { Nav as ReactNav, NavItem, NavLink } from "reactstrap";
import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import _ from "lodash"

export const Nav = ({ id, sections, vertical, tabs }) => {
  const history = useHistory();
  const location = useLocation();
  return (
    <ReactNav id={id} vertical={vertical} tabs={tabs}>
      {_.map(sections, (currsec, idx) => {
        if (!currsec) {
          return null;
        }
        const {
          label,
          route,
          exact = false,
          external = false,
          subsections,
          right,
          disabled,
          onClick,
        } = currsec;

        const active = matchPath(location.pathname, {
          path: route,
          exact,
        });

        return !subsections ? (
          <NavItem
            key={idx}
            active={active !== null}
            className={right ? "ml-auto" : ""}
          >
            <NavLink
              disabled={disabled}
              href="#"
              onClick={
                onClick
                  ? onClick
                  : () =>
                      external ? (window.location = route) : history.push(route)
              }
              active={active !== null}
            >
              {label}
            </NavLink>
          </NavItem>
        ) : (
          <Subsection key={idx} {...currsec} active={active !== null} />
        );
      })}
    </ReactNav>
  );
};

const Subsection = ({ label, subsections, active }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const history = useHistory();

  const toggle = () => setDropdownOpen(!dropdownOpen);

  return (
    <Dropdown nav isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle nav caret>
        {active ? <b>{label}</b> : label}
      </DropdownToggle>
      <DropdownMenu>
        {_.map(subsections, (curr, idx) => {
          const { label, route, external, disabled } = curr;

          return (
            <DropdownItem
              key={idx}
              disabled={disabled}
              onClick={() =>
                external ? (window.location = route) : history.push(route)
              }
            >
              {label}
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};
